import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutation'

Vue.use(Vuex);

const Store = new Vuex.Store({
  state,
  mutations,
})

export default Store;



// WEBPACK FOOTER //
// ./src/vuex/index.js